module.exports = __webpack_public_path__ + "static/img/login.262f56c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login.png
// module id = bD10
// module chunks = 122